import { AssetReference } from '@opallabs/cassini'
import { doNothing } from '../../helpers/functions/doNothing'
import { useValidModules } from '../../helpers/hooks'
import {
  Module,
  OnAddSectionProps,
  OnDragDropProps,
  OnShowAssetPickerProps,
} from '../../helpers/types'
import { SECTION_COMPONENT_NAME } from './constants'
import { DesktopSingle } from './displays/DesktopSingle'
import { MobileSingle } from './displays/MobileSingle'

export type Props = {
  accountImage: AssetReference | null
  accountName: string
  content: string
  display: string
  isExpanded: boolean
  isPresenting: boolean
  isSnapshot?: boolean
  modules: Module[]
  onAddSection?: (args: OnAddSectionProps) => void
  onDeleteSection?: (index: number) => void
  onDragDrop?: OnDragDropProps
  onExpandAsset?: (assetId: number) => void
  onRemoveAsset?: (assetId: number, index: number) => void
  onShowAssetPicker?: (args: OnShowAssetPickerProps) => void
  readOnly: boolean
  sound: string
  truncate: boolean
  updateSectionPostOption?: (index: number, value: string, name: string) => void
  updateText?: (val: string, destination: string) => void
}

const displays = {
  desktopSingle: DesktopSingle,
  mobileSingle: MobileSingle,
  default: MobileSingle,
}

const isValidDisplay = (display: string): display is keyof typeof displays =>
  Object.keys(displays).includes(display)

export const TikTokCarousel: React.FC<Props> = ({
  accountImage,
  accountName,
  content,
  display,
  isExpanded = false,
  isPresenting = false,
  isSnapshot = false,
  modules = [],
  onAddSection,
  onDeleteSection,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  readOnly = false,
  sound,
  truncate = false,
  updateSectionPostOption,
  updateText,
}) => {
  const validModules = useValidModules({
    modules,
    onAddSection: onAddSection ? onAddSection : doNothing,
    componentNames: [SECTION_COMPONENT_NAME],
  })
  const RenderDisplay = isValidDisplay(display)
    ? displays[display]
    : displays.default

  return (
    <RenderDisplay
      accountImage={accountImage}
      accountName={accountName}
      content={content}
      isExpanded={isExpanded}
      isPresenting={isPresenting}
      isSnapshot={isSnapshot}
      modules={validModules}
      onAddSection={onAddSection ? onAddSection : doNothing}
      onContentChange={(val: string) => updateText?.(val, 'content')}
      onDeleteSection={onDeleteSection ? onDeleteSection : doNothing}
      onDragDrop={onDragDrop ? onDragDrop : doNothing}
      onExpandAsset={onExpandAsset ? onExpandAsset : doNothing}
      onRemoveAsset={onRemoveAsset ? onRemoveAsset : doNothing}
      onShowAssetPicker={onShowAssetPicker ? onShowAssetPicker : doNothing}
      onSoundChange={(val: string) => updateText?.(val, 'sound')}
      readOnly={readOnly}
      sound={sound}
      truncate={truncate}
      updateSectionPostOption={
        updateSectionPostOption ? updateSectionPostOption : doNothing
      }
    />
  )
}
